import Loader from "@components/Loader";
import { LOGIN } from "@constants/routes";
import ResetPasswordForm from "@easydev/reset_password/ResetPasswordForm";
import logo from "@images/shared/logo.png";
import resetPassword from "@services/Core/Account/resetPassword";
import forgotPasswordValidate from "@validators/Security/Account/ForgotPassword.validate";
import { ReactElement, useState } from "react";
import { NavLink } from "react-router-dom";

const ForgotPassword = (): ReactElement => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessageReset, setErrorMessageReset] = useState("");
  const [successMessageReset, setSuccessMessageReset] = useState("");

  const handleForgotPassword = (FormValues: Record<string, any>) => {
    setIsLoading(true);

    resetPassword(FormValues.email)
      .then(async (result) => {
        setSuccessMessageReset(
          "An email has been sent to your mailbox. Follow the instructions."
        );
        setErrorMessageReset("");
      })
      .catch((error) => {
        setErrorMessageReset(error?.response?.data?.error);
        setSuccessMessageReset("");
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">
              <img src={logo} alt="logo" />
            </h3>
          </div>
          {isLoading ? (
            <Loader isInsideThing />
          ) : (
            <ResetPasswordForm
              onSubmit={(FormValues) => {
                handleForgotPassword(FormValues);
              }}
              validate={forgotPasswordValidate}
              errorMessage={errorMessageReset}
              successMessage={successMessageReset}
            />
          )}

          <div className="account__have-account">
            <p>
              Remember your password? <NavLink to={LOGIN}>Login</NavLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;
